import { render, staticRenderFns } from "./config-plan.vue?vue&type=template&id=f456a388"
import script from "./config-plan.vue?vue&type=script&lang=js"
export * from "./config-plan.vue?vue&type=script&lang=js"
import style0 from "./config-plan.vue?vue&type=style&index=0&id=f456a388&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports